<div class="grid flex-column">
  <div class="col">
    <div class="fluid formgrid grid">
      <div class="col-12 xl:col-4 sm:col-12">
        <app-companyselector [labelKey]="cliCliLabel" [parentCompany]="0" [selectedID]="document.DOCCLIENTSID" (selectedCompanyID)="cliCompanySelected($event)" disabled="true"></app-companyselector>
      </div>
      <div class="col-12 xl:col-4 sm:col-12">
        <app-personselector [labelKey]="cliPerLabel" [parentCompany]="document.DOCCLIENTSID" firstAvailable="true" [selectedID]="document.DOCPERSONID" (selectedPersonID)="cliPersonSelected($event)" disabled="true"></app-personselector>
      </div>
      <div class="col-12 xl:col-4 sm:col-12">
        <app-departmentselector [labelKey]="cliDepLabel" [parentCompany]="document.DOCCLIENTSID" [selectedID]="document.DOCCLIDEPID" (selectedDepartmentID)="cliStockSelected($event)" disabled="true"></app-departmentselector>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="fluid formgrid grid">
      <div class="col-12 xl:col-4 sm:col-12">
        <app-companyselector [labelKey]="pcoCliLabel" [parentCompany]="document.DOCCLIENTSID" [selectedID]="document.DOCPCOCLIID" (selectedCompanyID)="pcoCompanySelected($event)" disabled="true"></app-companyselector>
      </div>
      <div class="col-12 xl:col-4 sm:col-12">
        <app-personselector [labelKey]="pcoPerLabel" [parentCompany]="document.DOCPCOCLIID" firstAvailable="true" [selectedID]="document.DOCPCOPERID" select="first" (selectedPersonID)="pcoPersonSelected($event)" disabled="true"></app-personselector>
      </div>
      <div class="col-12 xl:col-4 sm:col-12">
        <app-departmentselector [labelKey]="pcoDepLabel"
                                [disabled]="true"
                                [parentCompany]="document.DOCPCOCLIID"
                                [selectedID]="document.DOCPCODEPID"
                                [masterID]="document.DOCCLIDEPID"
                                (selectedDepartmentID)="pcoStockSelected($event)">
        </app-departmentselector>
      </div>
    </div>
  </div>
</div>
